import React from 'react'

import {IDrawerContext} from './types'

export const DrawerContext = React.createContext<IDrawerContext>({})
